import { ICountriesDDI } from "./countries-ddi.model";

// Mapeia países para seus códigos ISO de 2 letras para flagcdn.com
const countryToIsoCode: Record<string, string> = {
  'Afeganistão': 'af',
  'África do Sul': 'za',
  'Albânia': 'al',
  'Alemanha': 'de',
  'Andorra': 'ad',
  'Angola': 'ao',
  'Anguilla': 'ai',
  'Antígua e Barbuda': 'ag',
  'Antilhas Holandesas': 'an',
  'Arábia Saudita': 'sa',
  'Argélia': 'dz',
  'Argentina': 'ar',
  'Armênia': 'am',
  'Aruba': 'aw',
  'Ascensão': 'ac',
  'Austrália': 'au',
  'Áustria': 'at',
  'Azerbaijão': 'az',
  'Bahamas': 'bs',
  'Bangladesh': 'bd',
  'Barbados': 'bb',
  'Bahrein': 'bh',
  'Bélgica': 'be',
  'Belize': 'bz',
  'Benim': 'bj',
  'Bermudas': 'bm',
  'Bielorrússia': 'by',
  'Bolívia': 'bo',
  'Bósnia e Herzegovina': 'ba',
  'Botswana': 'bw',
  'Brasil': 'br',
  'Brunei': 'bn',
  'Bulgária': 'bg',
  'Burkina Faso': 'bf',
  'Burundi': 'bi',
  'Butão': 'bt',
  'Cabo Verde': 'cv',
  'Camarões': 'cm',
  'Camboja': 'kh',
  'Canadá': 'ca',
  'Cazaquistão': 'kz',
  'Chade': 'td',
  'Chile': 'cl',
  'República Popular da China': 'cn',
  'Chipre': 'cy',
  'Colômbia': 'co',
  'Comores': 'km',
  'CongoBrazzaville': 'cg',
  'CongoKinshasa': 'cd',
  'Coreia do Norte': 'kp',
  'Coreia do Sul': 'kr',
  'Costa do Marfim': 'ci',
  'Costa Rica': 'cr',
  'Croácia': 'hr',
  'Cuba': 'cu',
  'Dinamarca': 'dk',
  'Djibuti': 'dj',
  'Dominica': 'dm',
  'Egipto': 'eg',
  'El Salvador': 'sv',
  'Emirados Árabes Unidos': 'ae',
  'Equador': 'ec',
  'Eritreia': 'er',
  'Eslováquia': 'sk',
  'Eslovénia': 'si',
  'Espanha': 'es',
  'Estados Unidos': 'us',
  'Estónia': 'ee',
  'Etiópia': 'et',
  'Fiji': 'fj',
  'Filipinas': 'ph',
  'Finlândia': 'fi',
  'França': 'fr',
  'Gabão': 'ga',
  'Gâmbia': 'gm',
  'Gana': 'gh',
  'Geórgia': 'ge',
  'Gibraltar': 'gi',
  'Granada': 'gd',
  'Grécia': 'gr',
  'Groenlândia': 'gl',
  'Guadalupe': 'gp',
  'Guam': 'gu',
  'Guatemala': 'gt',
  'Guiana': 'gy',
  'Guiana Francesa': 'gf',
  'Guiné': 'gn',
  'GuinéBissau': 'gw',
  'Guiné Equatorial': 'gq',
  'Haiti': 'ht',
  'Honduras': 'hn',
  'Hong Kong': 'hk',
  'Hungria': 'hu',
  'Iémen': 'ye',
  'Ilhas Cayman': 'ky',
  'Ilha Christmas': 'cx',
  'Ilhas Cocos': 'cc',
  'Ilhas Cook': 'ck',
  'Ilhas Féroe': 'fo',
  'Ilha Heard e Ilhas McDonald': 'hm',
  'Maldivas': 'mv',
  'Ilhas Malvinas': 'fk',
  'Ilhas Marianas do Norte': 'mp',
  'Ilhas Marshall': 'mh',
  'Ilha Norfolk': 'nf',
  'Ilhas Salomão': 'sb',
  'Ilhas Virgens Americanas': 'vi',
  'Ilhas Virgens Britânicas': 'vg',
  'Índia': 'in',
  'Indonésia': 'id',
  'Irã': 'ir',
  'Iraque': 'iq',
  'Irlanda': 'ie',
  'Islândia': 'is',
  'Israel': 'il',
  'Itália': 'it',
  'Jamaica': 'jm',
  'Japão': 'jp',
  'Jordânia': 'jo',
  'Kiribati': 'ki',
  'Kosovo': 'xk',
  'Kuwait': 'kw',
  'Laos': 'la',
  'Lesoto': 'ls',
  'Letônia': 'lv',
  'Líbano': 'lb',
  'Libéria': 'lr',
  'Líbia': 'ly',
  'Liechtenstein': 'li',
  'Lituânia': 'lt',
  'Luxemburgo': 'lu',
  'Macau': 'mo',
  'República da Macedônia': 'mk',
  'Madagascar': 'mg',
  'Malásia': 'my',
  'Malawi': 'mw',
  'Mali': 'ml',
  'Malta': 'mt',
  'Marrocos': 'ma',
  'Martinica': 'mq',
  'Maurícia': 'mu',
  'Mauritânia': 'mr',
  'Mayotte': 'yt',
  'México': 'mx',
  'Estados Federados da Micronésia': 'fm',
  'Moçambique': 'mz',
  'Moldávia': 'md',
  'Mônaco': 'mc',
  'Mongólia': 'mn',
  'Montenegro': 'me',
  'Montserrat': 'ms',
  'Myanmar': 'mm',
  'Namíbia': 'na',
  'Nauru': 'nr',
  'Nepal': 'np',
  'Nicarágua': 'ni',
  'Níger': 'ne',
  'Nigéria': 'ng',
  'Niue': 'nu',
  'Noruega': 'no',
  'Nova Caledônia': 'nc',
  'Nova Zelândia': 'nz',
  'Omã': 'om',
  'Países Baixos': 'nl',
  'Palau': 'pw',
  'Palestina': 'ps',
  'Panamá': 'pa',
  'PapuaNova Guiné': 'pg',
  'Paquistão': 'pk',
  'Paraguai': 'py',
  'Peru': 'pe',
  'Polinésia Francesa': 'pf',
  'Polônia': 'pl',
  'Porto Rico': 'pr',
  'Portugal': 'pt',
  'Qatar': 'qa',
  'Quênia': 'ke',
  'Quirguistão': 'kg',
  'Reino Unido': 'gb',
  'República CentroAfricana': 'cf',
  'República Dominicana': 'do',
  'República Tcheca': 'cz',
  'Reunião': 're',
  'Romênia': 'ro',
  'Ruanda': 'rw',
  'Rússia': 'ru',
  'Saara Ocidental': 'eh',
  'Samoa': 'ws',
  'Samoa Americana': 'as',
  'Santa Helena território': 'sh',
  'Santa Lúcia': 'lc',
  'São Cristóvão e Nevis': 'kn',
  'São Marinho': 'sm',
  'SaintPierre e Miquelon': 'pm',
  'São Vicente e Granadinas': 'vc',
  'Seicheles': 'sc',
  'Senegal': 'sn',
  'Serra Leoa': 'sl',
  'Sérvia': 'rs',
  'Singapura': 'sg',
  'Somália': 'so',
  'Sri Lanka': 'lk',
  'Suazilândia': 'sz',
  'Sudão': 'sd',
  'Sudão do Sul': 'ss',
  'Suécia': 'se',
  'Suíça': 'ch',
  'Suriname': 'sr',
  'Tadjiquistão': 'tj',
  'Tailândia': 'th',
  'República da China': 'tw',
  'Tanzânia': 'tz',
  'Território Britânico do Oceano Índico': 'io',
  'TimorLeste': 'tl',
  'Togo': 'tg',
  'Tokelau': 'tk',
  'Tonga': 'to',
  'Trinidad e Tobago': 'tt',
  'Tunísia': 'tn',
  'Turcas e Caicos': 'tc',
  'Turquemenistão': 'tm',
  'Turquia': 'tr',
  'Tuvalu': 'tv',
  'Ucrânia': 'ua',
  'Uganda': 'ug',
  'Uruguai': 'uy',
  'Uzbequistão': 'uz',
  'Vanuatu': 'vu',
  'Venezuela': 've',
  'Vietnã': 'vn',
  'Wallis e Futuna': 'wf',
  'Zâmbia': 'zm',
  'Zimbábue': 'zw'
};

// Função para obter o código ISO
function getIsoCode(countryName: string): string {
  // Alguns nomes podem ter caracteres especiais unicode escapados
  const normalizedName = countryName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return countryToIsoCode[countryName] || countryToIsoCode[normalizedName] || 'un'; // un = bandeira desconhecida
}

export const countriesDdi = [
  {
    "pais": "Afeganist\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Afeganistão")}.png`,
    "ddi": "+93"
  },
  {
    "pais": "\u00c1frica do Sul",
    "img": `https://flagcdn.com/w40/${getIsoCode("África do Sul")}.png`,
    "ddi": "+27"
  },
  {
    "pais": "Alb\u00e2nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Albânia")}.png`,
    "ddi": "+355"
  },
  {
    "pais": "Alemanha",
    "img": `https://flagcdn.com/w40/${getIsoCode("Alemanha")}.png`,
    "ddi": "+49"
  },
  {
    "pais": "Andorra",
    "img": `https://flagcdn.com/w40/${getIsoCode("Andorra")}.png`,
    "ddi": "+376"
  },
  {
    "pais": "Angola",
    "img": `https://flagcdn.com/w40/${getIsoCode("Angola")}.png`,
    "ddi": "+244"
  },
  {
    "pais": "Anguilla",
    "img": `https://flagcdn.com/w40/${getIsoCode("Anguilla")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Ant\u00edgua e Barbuda",
    "img": `https://flagcdn.com/w40/${getIsoCode("Antígua e Barbuda")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Ar\u00e1bia Saudita",
    "img": `https://flagcdn.com/w40/${getIsoCode("Arábia Saudita")}.png`,
    "ddi": "+966"
  },
  {
    "pais": "Arg\u00e9lia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Argélia")}.png`,
    "ddi": "+213"
  },
  {
    "pais": "Argentina",
    "img": `https://flagcdn.com/w40/${getIsoCode("Argentina")}.png`,
    "ddi": "+54"
  },
  {
    "pais": "Arm\u00eania",
    "img": `https://flagcdn.com/w40/${getIsoCode("Armênia")}.png`,
    "ddi": "+374"
  },
  {
    "pais": "Aruba",
    "img": `https://flagcdn.com/w40/${getIsoCode("Aruba")}.png`,
    "ddi": "+297"
  },
  {
    "pais": "Austr\u00e1lia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Austrália")}.png`,
    "ddi": "+61"
  },
  {
    "pais": "\u00c1ustria",
    "img": `https://flagcdn.com/w40/${getIsoCode("Áustria")}.png`,
    "ddi": "+43"
  },
  {
    "pais": "Azerbaij\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Azerbaijão")}.png`,
    "ddi": "+994"
  },
  {
    "pais": "Bahamas",
    "img": `https://flagcdn.com/w40/${getIsoCode("Bahamas")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Bangladesh",
    "img": `https://flagcdn.com/w40/${getIsoCode("Bangladesh")}.png`,
    "ddi": "+880"
  },
  {
    "pais": "Barbados",
    "img": `https://flagcdn.com/w40/${getIsoCode("Barbados")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Bahrein",
    "img": `https://flagcdn.com/w40/${getIsoCode("Bahrein")}.png`,
    "ddi": "+973"
  },
  {
    "pais": "B\u00e9lgica",
    "img": `https://flagcdn.com/w40/${getIsoCode("Bélgica")}.png`,
    "ddi": "+32"
  },
  {
    "pais": "Belize",
    "img": `https://flagcdn.com/w40/${getIsoCode("Belize")}.png`,
    "ddi": "+501"
  },
  {
    "pais": "Benim",
    "img": `https://flagcdn.com/w40/${getIsoCode("Benim")}.png`,
    "ddi": "+229"
  },
  {
    "pais": "Bermudas",
    "img": `https://flagcdn.com/w40/${getIsoCode("Bermudas")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Bielorr\u00fassia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Bielorrússia")}.png`,
    "ddi": "+375"
  },
  {
    "pais": "Bol\u00edvia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Bolívia")}.png`,
    "ddi": "+591"
  },
  {
    "pais": "B\u00f3snia e Herzegovina",
    "img": `https://flagcdn.com/w40/${getIsoCode("Bósnia e Herzegovina")}.png`,
    "ddi": "+387"
  },
  {
    "pais": "Botswana",
    "img": `https://flagcdn.com/w40/${getIsoCode("Botswana")}.png`,
    "ddi": "+267"
  },
  {
    "pais": "Brasil",
    "img": `https://flagcdn.com/w40/${getIsoCode("Brasil")}.png`,
    "ddi": "+55"
  },
  {
    "pais": "Brunei",
    "img": `https://flagcdn.com/w40/${getIsoCode("Brunei")}.png`,
    "ddi": "+673"
  },
  {
    "pais": "Bulg\u00e1ria",
    "img": `https://flagcdn.com/w40/${getIsoCode("Bulgária")}.png`,
    "ddi": "+359"
  },
  {
    "pais": "Burkina Faso",
    "img": `https://flagcdn.com/w40/${getIsoCode("Burkina Faso")}.png`,
    "ddi": "+226"
  },
  {
    "pais": "Burundi",
    "img": `https://flagcdn.com/w40/${getIsoCode("Burundi")}.png`,
    "ddi": "+257"
  },
  {
    "pais": "But\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Butão")}.png`,
    "ddi": "+975"
  },
  {
    "pais": "Cabo Verde",
    "img": `https://flagcdn.com/w40/${getIsoCode("Cabo Verde")}.png`,
    "ddi": "+238"
  },
  {
    "pais": "Camar\u00f5es",
    "img": `https://flagcdn.com/w40/${getIsoCode("Camarões")}.png`,
    "ddi": "+237"
  },
  {
    "pais": "Camboja",
    "img": `https://flagcdn.com/w40/${getIsoCode("Camboja")}.png`,
    "ddi": "+855"
  },
  {
    "pais": "Canad\u00e1",
    "img": `https://flagcdn.com/w40/${getIsoCode("Canadá")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Cazaquist\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Cazaquistão")}.png`,
    "ddi": "+7"
  },
  {
    "pais": "Chade",
    "img": `https://flagcdn.com/w40/${getIsoCode("Chade")}.png`,
    "ddi": "+235"
  },
  {
    "pais": "Chile",
    "img": `https://flagcdn.com/w40/${getIsoCode("Chile")}.png`,
    "ddi": "+56"
  },
  {
    "pais": "Rep\u00fablica Popular da China",
    "img": `https://flagcdn.com/w40/${getIsoCode("República Popular da China")}.png`,
    "ddi": "+86"
  },
  {
    "pais": "Chipre",
    "img": `https://flagcdn.com/w40/${getIsoCode("Chipre")}.png`,
    "ddi": "+357"
  },
  {
    "pais": "Col\u00f4mbia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Colômbia")}.png`,
    "ddi": "+57"
  },
  {
    "pais": "Comores",
    "img": `https://flagcdn.com/w40/${getIsoCode("Comores")}.png`,
    "ddi": "+269"
  },
  {
    "pais": "CongoBrazzaville",
    "img": `https://flagcdn.com/w40/${getIsoCode("CongoBrazzaville")}.png`,
    "ddi": "+242"
  },
  {
    "pais": "CongoKinshasa",
    "img": `https://flagcdn.com/w40/${getIsoCode("CongoKinshasa")}.png`,
    "ddi": "+243"
  },
  {
    "pais": "Coreia do Norte",
    "img": `https://flagcdn.com/w40/${getIsoCode("Coreia do Norte")}.png`,
    "ddi": "+850"
  },
  {
    "pais": "Coreia do Sul",
    "img": `https://flagcdn.com/w40/${getIsoCode("Coreia do Sul")}.png`,
    "ddi": "+82"
  },
  {
    "pais": "Costa do Marfim",
    "img": `https://flagcdn.com/w40/${getIsoCode("Costa do Marfim")}.png`,
    "ddi": "+225"
  },
  {
    "pais": "Costa Rica",
    "img": `https://flagcdn.com/w40/${getIsoCode("Costa Rica")}.png`,
    "ddi": "+506"
  },
  {
    "pais": "Cro\u00e1cia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Croácia")}.png`,
    "ddi": "+385"
  },
  {
    "pais": "Cuba",
    "img": `https://flagcdn.com/w40/${getIsoCode("Cuba")}.png`,
    "ddi": "+53"
  },
  {
    "pais": "Dinamarca",
    "img": `https://flagcdn.com/w40/${getIsoCode("Dinamarca")}.png`,
    "ddi": "+45"
  },
  {
    "pais": "Djibuti",
    "img": `https://flagcdn.com/w40/${getIsoCode("Djibuti")}.png`,
    "ddi": "+253"
  },
  {
    "pais": "Dominica",
    "img": `https://flagcdn.com/w40/${getIsoCode("Dominica")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Egipto",
    "img": `https://flagcdn.com/w40/${getIsoCode("Egipto")}.png`,
    "ddi": "+20"
  },
  {
    "pais": "El Salvador",
    "img": `https://flagcdn.com/w40/${getIsoCode("El Salvador")}.png`,
    "ddi": "+503"
  },
  {
    "pais": "Emirados \u00c1rabes Unidos",
    "img": `https://flagcdn.com/w40/${getIsoCode("Emirados Árabes Unidos")}.png`,
    "ddi": "+971"
  },
  {
    "pais": "Equador",
    "img": `https://flagcdn.com/w40/${getIsoCode("Equador")}.png`,
    "ddi": "+593"
  },
  {
    "pais": "Eritreia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Eritreia")}.png`,
    "ddi": "+291"
  },
  {
    "pais": "Eslov\u00e1quia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Eslováquia")}.png`,
    "ddi": "+421"
  },
  {
    "pais": "Eslov\u00e9nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Eslovénia")}.png`,
    "ddi": "+386"
  },
  {
    "pais": "Espanha",
    "img": `https://flagcdn.com/w40/${getIsoCode("Espanha")}.png`,
    "ddi": "+34"
  },
  {
    "pais": "Estados Unidos",
    "img": `https://flagcdn.com/w40/${getIsoCode("Estados Unidos")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Est\u00f3nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Estónia")}.png`,
    "ddi": "+372"
  },
  {
    "pais": "Eti\u00f3pia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Etiópia")}.png`,
    "ddi": "+251"
  },
  {
    "pais": "Fiji",
    "img": `https://flagcdn.com/w40/${getIsoCode("Fiji")}.png`,
    "ddi": "+679"
  },
  {
    "pais": "Filipinas",
    "img": `https://flagcdn.com/w40/${getIsoCode("Filipinas")}.png`,
    "ddi": "+63"
  },
  {
    "pais": "Finl\u00e2ndia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Finlândia")}.png`,
    "ddi": "+358"
  },
  {
    "pais": "Fran\u00e7a",
    "img": `https://flagcdn.com/w40/${getIsoCode("França")}.png`,
    "ddi": "+33"
  },
  {
    "pais": "Gab\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Gabão")}.png`,
    "ddi": "+241"
  },
  {
    "pais": "G\u00e2mbia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Gâmbia")}.png`,
    "ddi": "+220"
  },
  {
    "pais": "Gana",
    "img": `https://flagcdn.com/w40/${getIsoCode("Gana")}.png`,
    "ddi": "+233"
  },
  {
    "pais": "Ge\u00f3rgia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Geórgia")}.png`,
    "ddi": "+995"
  },
  {
    "pais": "Gibraltar",
    "img": `https://flagcdn.com/w40/${getIsoCode("Gibraltar")}.png`,
    "ddi": "+350"
  },
  {
    "pais": "Granada",
    "img": `https://flagcdn.com/w40/${getIsoCode("Granada")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Gr\u00e9cia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Grécia")}.png`,
    "ddi": "+30"
  },
  {
    "pais": "Groenl\u00e2ndia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Groenlândia")}.png`,
    "ddi": "+299"
  },
  {
    "pais": "Guadalupe",
    "img": `https://flagcdn.com/w40/${getIsoCode("Guadalupe")}.png`,
    "ddi": "+590"
  },
  {
    "pais": "Guam",
    "img": `https://flagcdn.com/w40/${getIsoCode("Guam")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Guatemala",
    "img": `https://flagcdn.com/w40/${getIsoCode("Guatemala")}.png`,
    "ddi": "+502"
  },
  {
    "pais": "Guiana",
    "img": `https://flagcdn.com/w40/${getIsoCode("Guiana")}.png`,
    "ddi": "+592"
  },
  {
    "pais": "Guiana Francesa",
    "img": `https://flagcdn.com/w40/${getIsoCode("Guiana Francesa")}.png`,
    "ddi": "+594"
  },
  {
    "pais": "Guin\u00e9",
    "img": `https://flagcdn.com/w40/${getIsoCode("Guiné")}.png`,
    "ddi": "+224"
  },
  {
    "pais": "Guin\u00e9Bissau",
    "img": `https://flagcdn.com/w40/${getIsoCode("GuinéBissau")}.png`,
    "ddi": "+245"
  },
  {
    "pais": "Guin\u00e9 Equatorial",
    "img": `https://flagcdn.com/w40/${getIsoCode("Guiné Equatorial")}.png`,
    "ddi": "+240"
  },
  {
    "pais": "Haiti",
    "img": `https://flagcdn.com/w40/${getIsoCode("Haiti")}.png`,
    "ddi": "+509"
  },
  {
    "pais": "Honduras",
    "img": `https://flagcdn.com/w40/${getIsoCode("Honduras")}.png`,
    "ddi": "+504"
  },
  {
    "pais": "Hong Kong",
    "img": `https://flagcdn.com/w40/${getIsoCode("Hong Kong")}.png`,
    "ddi": "+852"
  },
  {
    "pais": "Hungria",
    "img": `https://flagcdn.com/w40/${getIsoCode("Hungria")}.png`,
    "ddi": "+36"
  },
  {
    "pais": "I\u00eamen",
    "img": `https://flagcdn.com/w40/${getIsoCode("Iémen")}.png`,
    "ddi": "+967"
  },
  {
    "pais": "Ilhas Cayman",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilhas Cayman")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Ilha Christmas",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilha Christmas")}.png`,
    "ddi": "+672"
  },
  {
    "pais": "Ilhas Cocos",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilhas Cocos")}.png`,
    "ddi": "+672"
  },
  {
    "pais": "Ilhas Cook",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilhas Cook")}.png`,
    "ddi": "+682"
  },
  {
    "pais": "Ilhas F\u00e9roe",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilhas Féroe")}.png`,
    "ddi": "+298"
  },
  {
    "pais": "Ilha Heard e Ilhas McDonald",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilha Heard e Ilhas McDonald")}.png`,
    "ddi": "+672"
  },
  {
    "pais": "Maldivas",
    "img": `https://flagcdn.com/w40/${getIsoCode("Maldivas")}.png`,
    "ddi": "+960"
  },
  {
    "pais": "Ilhas Malvinas",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilhas Malvinas")}.png`,
    "ddi": "+500"
  },
  {
    "pais": "Ilhas Marianas do Norte",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilhas Marianas do Norte")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Ilhas Marshall",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilhas Marshall")}.png`,
    "ddi": "+692"
  },
  {
    "pais": "Ilha Norfolk",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilha Norfolk")}.png`,
    "ddi": "+672"
  },
  {
    "pais": "Ilhas Salom\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilhas Salomão")}.png`,
    "ddi": "+677"
  },
  {
    "pais": "Ilhas Virgens Americanas",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilhas Virgens Americanas")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Ilhas Virgens Brit\u00e2nicas",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ilhas Virgens Britânicas")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "\u00cdndia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Índia")}.png`,
    "ddi": "+91"
  },
  {
    "pais": "Indon\u00e9sia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Indonésia")}.png`,
    "ddi": "+62"
  },
  {
    "pais": "Ir\u00e3",
    "img": `https://flagcdn.com/w40/${getIsoCode("Irã")}.png`,
    "ddi": "+98"
  },
  {
    "pais": "Iraque",
    "img": `https://flagcdn.com/w40/${getIsoCode("Iraque")}.png`,
    "ddi": "+964"
  },
  {
    "pais": "Irlanda",
    "img": `https://flagcdn.com/w40/${getIsoCode("Irlanda")}.png`,
    "ddi": "+353"
  },
  {
    "pais": "Isl\u00e2ndia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Islândia")}.png`,
    "ddi": "+354"
  },
  {
    "pais": "Israel",
    "img": `https://flagcdn.com/w40/${getIsoCode("Israel")}.png`,
    "ddi": "+972"
  },
  {
    "pais": "It\u00e1lia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Itália")}.png`,
    "ddi": "+39"
  },
  {
    "pais": "Jamaica",
    "img": `https://flagcdn.com/w40/${getIsoCode("Jamaica")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Jap\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Japão")}.png`,
    "ddi": "+81"
  },
  {
    "pais": "Jord\u00e2nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Jordânia")}.png`,
    "ddi": "+962"
  },
  {
    "pais": "Kiribati",
    "img": `https://flagcdn.com/w40/${getIsoCode("Kiribati")}.png`,
    "ddi": "+686"
  },
  {
    "pais": "Kosovo",
    "img": `https://flagcdn.com/w40/${getIsoCode("Kosovo")}.png`,
    "ddi": "+383"
  },
  {
    "pais": "Kuwait",
    "img": `https://flagcdn.com/w40/${getIsoCode("Kuwait")}.png`,
    "ddi": "+965"
  },
  {
    "pais": "Laos",
    "img": `https://flagcdn.com/w40/${getIsoCode("Laos")}.png`,
    "ddi": "+856"
  },
  {
    "pais": "Lesoto",
    "img": `https://flagcdn.com/w40/${getIsoCode("Lesoto")}.png`,
    "ddi": "+266"
  },
  {
    "pais": "Let\u00f4nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Letônia")}.png`,
    "ddi": "+371"
  },
  {
    "pais": "L\u00edbano",
    "img": `https://flagcdn.com/w40/${getIsoCode("Líbano")}.png`,
    "ddi": "+961"
  },
  {
    "pais": "Lib\u00e9ria",
    "img": `https://flagcdn.com/w40/${getIsoCode("Libéria")}.png`,
    "ddi": "+231"
  },
  {
    "pais": "L\u00edbia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Líbia")}.png`,
    "ddi": "+218"
  },
  {
    "pais": "Liechtenstein",
    "img": `https://flagcdn.com/w40/${getIsoCode("Liechtenstein")}.png`,
    "ddi": "+423"
  },
  {
    "pais": "Litu\u00e2nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Lituânia")}.png`,
    "ddi": "+370"
  },
  {
    "pais": "Luxemburgo",
    "img": `https://flagcdn.com/w40/${getIsoCode("Luxemburgo")}.png`,
    "ddi": "+352"
  },
  {
    "pais": "Macau",
    "img": `https://flagcdn.com/w40/${getIsoCode("Macau")}.png`,
    "ddi": "+853"
  },
  {
    "pais": "Rep\u00fablica da Maced\u00f4nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("República da Macedônia")}.png`,
    "ddi": "+389"
  },
  {
    "pais": "Madagascar",
    "img": `https://flagcdn.com/w40/${getIsoCode("Madagascar")}.png`,
    "ddi": "+261"
  },
  {
    "pais": "Mal\u00e1sia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Malásia")}.png`,
    "ddi": "+60"
  },
  {
    "pais": "Malawi",
    "img": `https://flagcdn.com/w40/${getIsoCode("Malawi")}.png`,
    "ddi": "+265"
  },
  {
    "pais": "Mali",
    "img": `https://flagcdn.com/w40/${getIsoCode("Mali")}.png`,
    "ddi": "+223"
  },
  {
    "pais": "Malta",
    "img": `https://flagcdn.com/w40/${getIsoCode("Malta")}.png`,
    "ddi": "+356"
  },
  {
    "pais": "Marrocos",
    "img": `https://flagcdn.com/w40/${getIsoCode("Marrocos")}.png`,
    "ddi": "+212"
  },
  {
    "pais": "Martinica",
    "img": `https://flagcdn.com/w40/${getIsoCode("Martinica")}.png`,
    "ddi": "+596"
  },
  {
    "pais": "Maur\u00edcia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Maurícia")}.png`,
    "ddi": "+230"
  },
  {
    "pais": "Maurit\u00e2nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Mauritânia")}.png`,
    "ddi": "+222"
  },
  {
    "pais": "Mayotte",
    "img": `https://flagcdn.com/w40/${getIsoCode("Mayotte")}.png`,
    "ddi": "+269"
  },
  {
    "pais": "M\u00e9xico",
    "img": `https://flagcdn.com/w40/${getIsoCode("México")}.png`,
    "ddi": "+52"
  },
  {
    "pais": "Estados Federados da Micron\u00e9sia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Estados Federados da Micronésia")}.png`,
    "ddi": "+691"
  },
  {
    "pais": "Mo\u00e7ambique",
    "img": `https://flagcdn.com/w40/${getIsoCode("Moçambique")}.png`,
    "ddi": "+258"
  },
  {
    "pais": "Mold\u00e1via",
    "img": `https://flagcdn.com/w40/${getIsoCode("Moldávia")}.png`,
    "ddi": "+373"
  },
  {
    "pais": "M\u00f4naco",
    "img": `https://flagcdn.com/w40/${getIsoCode("Mônaco")}.png`,
    "ddi": "+377"
  },
  {
    "pais": "Mong\u00f3lia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Mongólia")}.png`,
    "ddi": "+976"
  },
  {
    "pais": "Montenegro",
    "img": `https://flagcdn.com/w40/${getIsoCode("Montenegro")}.png`,
    "ddi": "+382"
  },
  {
    "pais": "Montserrat",
    "img": `https://flagcdn.com/w40/${getIsoCode("Montserrat")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Myanmar",
    "img": `https://flagcdn.com/w40/${getIsoCode("Myanmar")}.png`,
    "ddi": "+95"
  },
  {
    "pais": "Nam\u00edbia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Namíbia")}.png`,
    "ddi": "+264"
  },
  {
    "pais": "Nauru",
    "img": `https://flagcdn.com/w40/${getIsoCode("Nauru")}.png`,
    "ddi": "+674"
  },
  {
    "pais": "Nepal",
    "img": `https://flagcdn.com/w40/${getIsoCode("Nepal")}.png`,
    "ddi": "+977"
  },
  {
    "pais": "Nicar\u00e1gua",
    "img": `https://flagcdn.com/w40/${getIsoCode("Nicarágua")}.png`,
    "ddi": "+505"
  },
  {
    "pais": "N\u00edger",
    "img": `https://flagcdn.com/w40/${getIsoCode("Níger")}.png`,
    "ddi": "+227"
  },
  {
    "pais": "Nig\u00e9ria",
    "img": `https://flagcdn.com/w40/${getIsoCode("Nigéria")}.png`,
    "ddi": "+234"
  },
  {
    "pais": "Niue",
    "img": `https://flagcdn.com/w40/${getIsoCode("Niue")}.png`,
    "ddi": "+683"
  },
  {
    "pais": "Noruega",
    "img": `https://flagcdn.com/w40/${getIsoCode("Noruega")}.png`,
    "ddi": "+47"
  },
  {
    "pais": "Nova Caled\u00f4nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Nova Caledônia")}.png`,
    "ddi": "+687"
  },
  {
    "pais": "Nova Zel\u00e2ndia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Nova Zelândia")}.png`,
    "ddi": "+64"
  },
  {
    "pais": "Om\u00e3",
    "img": `https://flagcdn.com/w40/${getIsoCode("Omã")}.png`,
    "ddi": "+968"
  },
  {
    "pais": "Pa\u00edses Baixos",
    "img": `https://flagcdn.com/w40/${getIsoCode("Países Baixos")}.png`,
    "ddi": "+31"
  },
  {
    "pais": "Palau",
    "img": `https://flagcdn.com/w40/${getIsoCode("Palau")}.png`,
    "ddi": "+680"
  },
  {
    "pais": "Palestina",
    "img": `https://flagcdn.com/w40/${getIsoCode("Palestina")}.png`,
    "ddi": "+970"
  },
  {
    "pais": "Panam\u00e1",
    "img": `https://flagcdn.com/w40/${getIsoCode("Panamá")}.png`,
    "ddi": "+507"
  },
  {
    "pais": "PapuaNova Guin\u00e9",
    "img": `https://flagcdn.com/w40/${getIsoCode("PapuaNova Guiné")}.png`,
    "ddi": "+675"
  },
  {
    "pais": "Paquist\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Paquistão")}.png`,
    "ddi": "+92"
  },
  {
    "pais": "Paraguai",
    "img": `https://flagcdn.com/w40/${getIsoCode("Paraguai")}.png`,
    "ddi": "+595"
  },
  {
    "pais": "Peru",
    "img": `https://flagcdn.com/w40/${getIsoCode("Peru")}.png`,
    "ddi": "+51"
  },
  {
    "pais": "Polin\u00e9sia Francesa",
    "img": `https://flagcdn.com/w40/${getIsoCode("Polinésia Francesa")}.png`,
    "ddi": "+689"
  },
  {
    "pais": "Pol\u00f4nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Polônia")}.png`,
    "ddi": "+48"
  },
  {
    "pais": "Porto Rico",
    "img": `https://flagcdn.com/w40/${getIsoCode("Porto Rico")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Portugal",
    "img": `https://flagcdn.com/w40/${getIsoCode("Portugal")}.png`,
    "ddi": "+351"
  },
  {
    "pais": "Qatar",
    "img": `https://flagcdn.com/w40/${getIsoCode("Qatar")}.png`,
    "ddi": "+974"
  },
  {
    "pais": "Qu\u00eania",
    "img": `https://flagcdn.com/w40/${getIsoCode("Quênia")}.png`,
    "ddi": "+254"
  },
  {
    "pais": "Quirguist\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Quirguistão")}.png`,
    "ddi": "+996"
  },
  {
    "pais": "Reino Unido",
    "img": `https://flagcdn.com/w40/${getIsoCode("Reino Unido")}.png`,
    "ddi": "+44"
  },
  {
    "pais": "Rep\u00fablica CentroAfricana",
    "img": `https://flagcdn.com/w40/${getIsoCode("República CentroAfricana")}.png`,
    "ddi": "+236"
  },
  {
    "pais": "Rep\u00fablica Dominicana",
    "img": `https://flagcdn.com/w40/${getIsoCode("República Dominicana")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Rep\u00fablica Tcheca",
    "img": `https://flagcdn.com/w40/${getIsoCode("República Tcheca")}.png`,
    "ddi": "+420"
  },
  {
    "pais": "Reuni\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Reunião")}.png`,
    "ddi": "+262"
  },
  {
    "pais": "Rom\u00eania",
    "img": `https://flagcdn.com/w40/${getIsoCode("Romênia")}.png`,
    "ddi": "+40"
  },
  {
    "pais": "Ruanda",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ruanda")}.png`,
    "ddi": "+250"
  },
  {
    "pais": "R\u00fassia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Rússia")}.png`,
    "ddi": "+7"
  },
  {
    "pais": "Saara Ocidental",
    "img": `https://flagcdn.com/w40/${getIsoCode("Saara Ocidental")}.png`,
    "ddi": "+212"
  },
  {
    "pais": "Samoa",
    "img": `https://flagcdn.com/w40/${getIsoCode("Samoa")}.png`,
    "ddi": "+685"
  },
  {
    "pais": "Samoa Americana",
    "img": `https://flagcdn.com/w40/${getIsoCode("Samoa Americana")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Santa Helena territ\u00f3rio",
    "img": `https://flagcdn.com/w40/${getIsoCode("Santa Helena território")}.png`,
    "ddi": "+290"
  },
  {
    "pais": "Santa Lúcia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Santa Lúcia")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "S\u00e3o Crist\u00f3v\u00e3o e Nevis",
    "img": `https://flagcdn.com/w40/${getIsoCode("São Cristóvão e Nevis")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "S\u00e3o Marinho",
    "img": `https://flagcdn.com/w40/${getIsoCode("São Marinho")}.png`,
    "ddi": "+378"
  },
  {
    "pais": "SaintPierre e Miquelon",
    "img": `https://flagcdn.com/w40/${getIsoCode("SaintPierre e Miquelon")}.png`,
    "ddi": "+508"
  },
  {
    "pais": "S\u00e3o Tom\u00e9 e Pr\u00edncipe",
    "img": `https://flagcdn.com/w40/${getIsoCode("São Tomé e Príncipe")}.png`,
    "ddi": "+239"
  },
  {
    "pais": "S\u00e3o Vicente e Granadinas",
    "img": `https://flagcdn.com/w40/${getIsoCode("São Vicente e Granadinas")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Seicheles",
    "img": `https://flagcdn.com/w40/${getIsoCode("Seicheles")}.png`,
    "ddi": "+248"
  },
  {
    "pais": "Senegal",
    "img": `https://flagcdn.com/w40/${getIsoCode("Senegal")}.png`,
    "ddi": "+221"
  },
  {
    "pais": "Serra Leoa",
    "img": `https://flagcdn.com/w40/${getIsoCode("Serra Leoa")}.png`,
    "ddi": "+232"
  },
  {
    "pais": "S\u00e9rvia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Sérvia")}.png`,
    "ddi": "+381"
  },
  {
    "pais": "Singapura",
    "img": `https://flagcdn.com/w40/${getIsoCode("Singapura")}.png`,
    "ddi": "+65"
  },
  {
    "pais": "S\u00edria",
    "img": `https://flagcdn.com/w40/${getIsoCode("Síria")}.png`,
    "ddi": "+963"
  },
  {
    "pais": "Som\u00e1lia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Somália")}.png`,
    "ddi": "+252"
  },
  {
    "pais": "Sri Lanka",
    "img": `https://flagcdn.com/w40/${getIsoCode("Sri Lanka")}.png`,
    "ddi": "+94"
  },
  {
    "pais": "Suazil\u00e2ndia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Suazilândia")}.png`,
    "ddi": "+268"
  },
  {
    "pais": "Sud\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Sudão")}.png`,
    "ddi": "+249"
  },
  {
    "pais": "Sud\u00e3o do Sul",
    "img": `https://flagcdn.com/w40/${getIsoCode("Sudão do Sul")}.png`,
    "ddi": "+211"
  },
  {
    "pais": "Su\u00e9cia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Suécia")}.png`,
    "ddi": "+46"
  },
  {
    "pais": "Su\u00ed\u00e7a",
    "img": `https://flagcdn.com/w40/${getIsoCode("Suíça")}.png`,
    "ddi": "+41"
  },
  {
    "pais": "Suriname",
    "img": `https://flagcdn.com/w40/${getIsoCode("Suriname")}.png`,
    "ddi": "+597"
  },
  {
    "pais": "Tadjiquist\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Tadjiquistão")}.png`,
    "ddi": "+992"
  },
  {
    "pais": "Tail\u00e2ndia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Tailândia")}.png`,
    "ddi": "+66"
  },
  {
    "pais": "Rep\u00fablica da China",
    "img": `https://flagcdn.com/w40/${getIsoCode("República da China")}.png`,
    "ddi": "+886"
  },
  {
    "pais": "Tanz\u00e2nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Tanzânia")}.png`,
    "ddi": "+255"
  },
  {
    "pais": "Territ\u00f3rio Brit\u00e2nico do Oceano \u00cdndico",
    "img": `https://flagcdn.com/w40/${getIsoCode("Território Britânico do Oceano Índico")}.png`,
    "ddi": "+246"
  },
  {
    "pais": "TimorLeste",
    "img": `https://flagcdn.com/w40/${getIsoCode("TimorLeste")}.png`,
    "ddi": "+670"
  },
  {
    "pais": "Togo",
    "img": `https://flagcdn.com/w40/${getIsoCode("Togo")}.png`,
    "ddi": "+228"
  },
  {
    "pais": "Tokelau",
    "img": `https://flagcdn.com/w40/${getIsoCode("Tokelau")}.png`,
    "ddi": "+690"
  },
  {
    "pais": "Tonga",
    "img": `https://flagcdn.com/w40/${getIsoCode("Tonga")}.png`,
    "ddi": "+676"
  },
  {
    "pais": "Trinidad e Tobago",
    "img": `https://flagcdn.com/w40/${getIsoCode("Trinidad e Tobago")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Tun\u00edsia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Tunísia")}.png`,
    "ddi": "+216"
  },
  {
    "pais": "Turcas e Caicos",
    "img": `https://flagcdn.com/w40/${getIsoCode("Turcas e Caicos")}.png`,
    "ddi": "+1"
  },
  {
    "pais": "Turquemenist\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Turquemenistão")}.png`,
    "ddi": "+993"
  },
  {
    "pais": "Turquia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Turquia")}.png`,
    "ddi": "+90"
  },
  {
    "pais": "Tuvalu",
    "img": `https://flagcdn.com/w40/${getIsoCode("Tuvalu")}.png`,
    "ddi": "+688"
  },
  {
    "pais": "Ucr\u00e2nia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Ucrânia")}.png`,
    "ddi": "+380"
  },
  {
    "pais": "Uganda",
    "img": `https://flagcdn.com/w40/${getIsoCode("Uganda")}.png`,
    "ddi": "+256"
  },
  {
    "pais": "Uruguai",
    "img": `https://flagcdn.com/w40/${getIsoCode("Uruguai")}.png`,
    "ddi": "+598"
  },
  {
    "pais": "Uzbequist\u00e3o",
    "img": `https://flagcdn.com/w40/${getIsoCode("Uzbequistão")}.png`,
    "ddi": "+998"
  },
  {
    "pais": "Vanuatu",
    "img": `https://flagcdn.com/w40/${getIsoCode("Vanuatu")}.png`,
    "ddi": "+678"
  },
  {
    "pais": "Vaticano",
    "img": `https://flagcdn.com/w40/${getIsoCode("Vaticano")}.png`,
    "ddi": "+379"
  },
  {
    "pais": "Venezuela",
    "img": `https://flagcdn.com/w40/${getIsoCode("Venezuela")}.png`,
    "ddi": "+58"
  },
  {
    "pais": "Vietn\u00e3",
    "img": `https://flagcdn.com/w40/${getIsoCode("Vietnã")}.png`,
    "ddi": "+84"
  },
  {
    "pais": "Wallis e Futuna",
    "img": `https://flagcdn.com/w40/${getIsoCode("Wallis e Futuna")}.png`,
    "ddi": "+681"
  },
  {
    "pais": "Z\u00e2mbia",
    "img": `https://flagcdn.com/w40/${getIsoCode("Zâmbia")}.png`,
    "ddi": "+260"
  },
  {
    "pais": "Zimb\u00e1bue",
    "img": `https://flagcdn.com/w40/${getIsoCode("Zimbábue")}.png`,
    "ddi": "+263"
  }
] as ICountriesDDI[];